import { Component } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-theme-settings',
  templateUrl: './theme-settings.page.html',
  styleUrls: ['./theme-settings.page.scss'],
})
export class ThemeSettingsPage {
  theme = 'light';

  constructor(protected modalCtrl: ModalController) {
    this.loadTheme();
  }

  async loadTheme() {
    const savedTheme = await Preferences.get({ key: 'theme' });

    if (savedTheme.value) {
      this.theme = savedTheme.value;
    } else {
      // Detecta a preferência do sistema
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      this.theme = prefersDark ? 'dark' : 'light';
    }

    this.applyTheme(this.theme);
  }

  async setTheme(theme: string) {
    this.theme = theme;
    await Preferences.set({ key: 'theme', value: theme });
    this.applyTheme(theme);
  }

  applyTheme(theme: string) {
    let newTheme;
    if(this.theme === 'system') {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      newTheme = prefersDark ? 'dark' : 'light'
    }else{
      this.theme = theme;
      newTheme = theme;
    }
    document.documentElement.setAttribute('color-theme', newTheme);
  }

  goBack(){
    document.getElementById("contentDiv")?.classList.add('animation');
    this.modalCtrl.dismiss();
  }
  
}
